import { Card, Group, Text, UnstyledButton } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import { DomainKey, DOMAINS } from '../../config/domains';
import { getContrastingTextColor } from '../../utils/color';

interface DomainTileProps {
  domainKey: DomainKey;
}

export default function DomainTile({ domainKey }: DomainTileProps) {
  const navigate = useNavigate();
  const domain = DOMAINS[domainKey];

  const gradientBg = 'linear-gradient(135deg, #5B21FF, #9F7AEA)';
  const autoTextColor = useMemo(
    () => getContrastingTextColor(gradientBg),
    [gradientBg]
  );

  if (!domain) return null;

  return (
    <UnstyledButton onClick={() => navigate(domain.basePath)} style={{ width: '100%' }}>
      <Card
        radius="lg"
        p="lg"
        style={{
          backgroundImage: gradientBg,
          color: autoTextColor,
        }}
      >
        <Group align="flex-start" gap="md">
          {domain.icon}
          <div>
            <Text fw={600} size="lg">
              {domain.label}
            </Text>
            <Text size="sm" c={autoTextColor} style={{ opacity: 0.9 }}>
              {domain.description}
            </Text>
          </div>
        </Group>
      </Card>
    </UnstyledButton>
  );
}
